import { AppDispatch } from '../../../../store'
import Client from '../Client/Client'
import { IHoliday } from '../Client/IHoliday'

import {
  GET_HOLIDAYS,
  GET_HOLIDAYS_FAILURE,
  GET_HOLIDAYS_SUCCESS,
} from './ActionTypes'

export const getHolidays = (countryCode: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_HOLIDAYS })
    return Client.getHolidays(countryCode).then(
      (holidays: IHoliday[]) => dispatch(getHolidaysSuccess(holidays)),
      () => dispatch(getHolidaysFailure()),
    )
  }
}

const getHolidaysSuccess = (holidays: IHoliday[]) => {
  return {
    type: GET_HOLIDAYS_SUCCESS,
    payload: {
      holidays,
    },
  }
}

const getHolidaysFailure = () => {
  return {
    type: GET_HOLIDAYS_FAILURE,
  }
}
